
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import moment from "moment"
import { FaCircleCheck } from "react-icons/fa6";
import { FaCircleXmark } from "react-icons/fa6";
import cn from "classnames"
import Btn from "../../shared/button/Btn"
import { allLoadBulkResponse } from "../../../features/loadBulk/loadBulkSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;    
        position: relative;
        .content{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: ${({theme}) => theme.mainTextColor};
            padding: 30px;
            overflow: auto;

            .result-container{
                display: flex;
                flex-direction: column;
                width: 100%;
                .result-detail{
                    border-bottom: 2px solid ${({theme}) => theme.mainBorderColor};
                    padding: 20px 10px;
                    cursor: pointer;
                    .result-date{
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        p{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                        }
                        span{
                            font-size: var(--font-size-xs);
                            font-weight: var(--font-weight-md);
                        }
                    }
                    .copy{
                        
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        button{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-md);
                            margin-top: 10px;
                            color: var(--color-main);
                            text-decoration: underline;
                        }
                        p{
                            margin-top: 10px;
                            font-size: var(--font-size-xs);
                            font-weight: var(--font-weight-md);
                        }
                    }
                    
                }
                .result{
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    gap: 20px;
                    p{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                    svg{
                        width: 25px;
                        height: 25px;

                    }
                }
            }
        }
        .btn-container{
            display: flex;
            align-items: center;
            justify-content: center;
            position: sticky;
            bottom: 0px;
            width: 100%;
            padding-block: 20px;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
    .green{
        color: green;
    }
    .red{
        color: var(--color-main);
    }
    .border{
        border-bottom: 3px solid ${({theme}) => theme.mainBorderColor};
    }
    .open-item{
        background-color: ${({theme}) => theme.secondaryBgColor};
    }

`

const AllLoadBulkModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {loadBulkList} = useSelector(state => state.loadList)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [groupedData, setGroupedData] = useState({});
    const [openAccordion, setOpenAccordion] = useState(null);
    const [copyMessage, setCopyMessage] = useState(""); 


    useEffect(() => {
        dispatch(allLoadBulkResponse())
    }, [])

    useEffect(() => {
        const grouped = loadBulkList.reduce((acc, item) => {
          acc[item.resultId] = acc[item.resultId] || [];
          acc[item.resultId].push(item);
          return acc;
        }, {});
        setGroupedData(grouped);
    }, [loadBulkList]);

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showNestedModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleAccordionToggle = (resultId) => {
        setOpenAccordion(openAccordion === resultId ? null : resultId);
    };

    const copyToClipboard = (items, e) => {
        e.stopPropagation();
        const copyData = items
          .map((item, i) => {
            const index = i + 1;
            return `${index}\t${item.result}\t${
              item.isSuccess ? "Başarılı" : "Başarısız"
            }`;
          })
          .join("\n");
      
        navigator.clipboard
        .writeText(copyData)
        .then(() => {
            setCopyMessage("Veriler kopyalandı! Excel'e yapıştırabilirsiniz."); 
            setTimeout(() => setCopyMessage(""), 2000); 
        })
        .catch((err) => {
            console.error("Kopyalama işlemi başarısız!", err);
            setCopyMessage("Kopyalama sırasında bir hata oluştu!");
            setTimeout(() => setCopyMessage(""), 2000);
        });
      };
      


  return (
    <Container>
        <div className="modal">
            <PageTopTitle isDiffPage title={"Toplu Yük Sonuçları"}/>

            <div className="content">
                <div className="result-container">
                    {Object.entries(groupedData).map(([resultId, items]) => (
                    <div
                        onClick={() => handleAccordionToggle(resultId)}
                        className={cn("result-detail", openAccordion === resultId ? "open-item" : "")}
                        key={resultId}
                    >
                        <div className="result-date">
                            <p>{moment(items[0].createdDate).format("DD.MM.YYYY HH:mm:ss")}</p>
                            <span>({items[0].fileName})</span>
                        </div>
                        {openAccordion === resultId && (
                        <>
                            <div className="copy">
                                <button onClick={(e) => copyToClipboard(items, e)}>Verileri Kopyala</button>
                                {copyMessage && <p>{copyMessage}</p>}
                            </div>
                            {items.map((item, i) => {
                            const index = i + 1;
                            return (
                                <div className="result" key={item.id}>
                                <p>({index})</p>
                                <p>{item.result}</p>
                                <p>
                                    {item.isSuccess ? (
                                    <FaCircleCheck className="green" />
                                    ) : (
                                    <FaCircleXmark className="red" />
                                    )}
                                </p>
                                </div>
                            );
                            })}
                        </>
                        )}
                    </div>
                    ))}
                </div>
            </div>
            <div className="btn-container">
                <Btn width={"200px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showNestedModal(null))}>Kapat</Btn>
            </div>
        </div>
    </Container>
  )
}

export default AllLoadBulkModal